import { useAppSelector } from 'app/hooks';
import FeatureTitleBar from 'components/common/FeatureTitleBar';
import StatusHeader from 'components/common/StatusHeader';
import { CONST_DEL_SUBMENU_TITLE_FILTER } from 'features/SubTitleMenu/constans';
import { selectIsEditMode } from 'features/common/editModeSlice';
import { FormEvent, useEffect, useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { formatDate } from 'utils';
import { MenuDetail } from '../../models/SubTitleMenu';
import './List.scss';
import Filter from './components/Filter';
import TableList from './components/TableList';
import service from './services';

function List() {
  const { t } = useTranslation();
  const history = useHistory();

  // selectors
  const isEditMode = useAppSelector(selectIsEditMode);

  // states
  const [menuName, setNameGenre] = useState('');
  const [menuCode, setMenuCode] = useState('');
  const [dataTable, setDataTable] = useState<MenuDetail[] | []>();
  const [deleteFlg, setDeleteFlg] = useState(CONST_DEL_SUBMENU_TITLE_FILTER.HIDE_DEL);
  const [expiredDate, setExpiredDate] = useState(new Date());
  const [menuPos, setMenuPos] = useState('');

  // call API
  async function filterAPI(name: string, code: string, delete_flg: number, expiredDate: string, menuPos: string) {
    await service
      .getSubTitleMenus(name, code, delete_flg, expiredDate, menuPos)
      .then((result) => {
        setDataTable(result.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // handle reload
  async function handleReload() {
    await service.getSubTitleMenus(menuName, menuCode, deleteFlg, formatDate(expiredDate), menuPos).then((result) => {
      setDataTable(result.data);
    });
  }

  // first load page
  useEffect(() => {
    async function getDataTable(name: string, code: string, deleteFlg: number, expiredDate: string, menuPos: string) {
      filterAPI(name, code, deleteFlg, expiredDate, menuPos);
    }
    getDataTable(menuName, menuCode, deleteFlg, formatDate(expiredDate), menuPos);
    /* eslint-disable react-hooks/exhaustive-deps */
  }, []);

  // search name
  function handleFilter(e: FormEvent) {
    e.preventDefault();
    filterAPI(menuName, menuCode, deleteFlg, formatDate(expiredDate), menuPos);
  }

  return (
    <div className="page-wrapper">
      <div className="page-header">
        <StatusHeader onAction={() => history.push('/')} />
      </div>
      <div className={`page-main ${isEditMode ? 'reedit-mode-wrapper' : ''}`}>
        <div className="page-content d-flex flex-column">
          <div className="mb-3">
            <FeatureTitleBar title={t('SubTitleMenu.Title')} />
          </div>
          <div className="mb-2">
            <Filter
              setName={setNameGenre}
              name={menuName}
              expiredDate={expiredDate}
              deleteFlg={deleteFlg}
              menuPos={menuPos}
              handleFilter={handleFilter}
              setDeleteFlg={setDeleteFlg}
              setExpiredDate={setExpiredDate}
              code={menuCode}
              setCode={setMenuCode}
              setMenuPos={setMenuPos}
            ></Filter>
          </div>

          {dataTable && (
            <TableList dataTable={dataTable} setDataTable={setDataTable} handleReload={handleReload}></TableList>
          )}
        </div>
      </div>
    </div>
  );
}
export default List;
